exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-Modal-Root {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(16,16,16,0.9);\n  z-index: 1000;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n}\n.Discussion-Modal-Window {\n  background-color: #fff;\n  box-sizing: border-box;\n  padding: 30px 40px;\n  width: 500px;\n  max-width: calc(100% - 40px);\n  border-radius: 10px;\n}\n@media (max-width: 480px) {\n  .Discussion-Modal-Window {\n    padding: 15px 20px;\n  }\n}\n", ""]);

// exports
